import React, { useEffect } from "react";

import {
  Heading,
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material"; 

import Aos from "aos";
import "aos/dist/aos.css";
const Background = styled.div`
  background-color: black;
  padding: 19px 0px 500px 0;
  @media screen and (max-width: 599px) {
    padding: 19px 0px 0px 0;
  }
`;

const Intro = styled(Grid)`
  padding: 25px 0px;
  height: 100vh;
  display: flex;
  border: 1px solid black;
  @media screen and (max-width: 899px) {
    // padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const IntroImage = styled(Grid)`
  padding: 50px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const RoadImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 900px;
`;


const Div = styled.div``;

const S3_About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <div id="roadmap">
      <Background>
        <Container maxWidth="xl">
          <Grid container style={{ textAlign: "center" }}>
            <Intro
              xs={12}
              md={12}
              p599="30px 0 0 0"
              align="center"
              style={{ paddingTop: "90px" }}
            >
              <Div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                // data-aos-delay="500"
                // data-aos-offset="0"
                data-aos-duration="1500"
                style={{ width: "100%" }}
              >
                <SectionHeading
                  style={{ textAlign: "center", paddingBottom: "80px" }}
                >
                  Roadmap
                </SectionHeading>
                <RoadImage
                  src="/images/road.png" 
                />
              </Div>
            </Intro>
          </Grid>
        </Container>
      </Background>
    </div>
  );
};

export default S3_About;
